// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { MedicalBISiteOfCareAddress } from './medicalBISiteOfCareAddress.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicalBiSiteOfCare {
    'name'?: string;
    'npi'?: string;
    'taxID'?: string;
    'address'?: MedicalBISiteOfCareAddress | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalBiSiteOfCare>> = [
        {
            "name":     "name",
            "baseName": "name",
            "type":     "string"
        },
        {
            "name":     "npi",
            "baseName": "npi",
            "type":     "string"
        },
        {
            "name":     "taxID",
            "baseName": "taxID",
            "type":     "string"
        },
        {
            "name":     "address",
            "baseName": "address",
            "type":     "MedicalBISiteOfCareAddress"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalBiSiteOfCare.attributeTypeMap;
    }
}
